import MediaGalleryImage from './MediaGalleryImage.js';
export default MediaGalleryImage;
//# sourceMappingURL=index.js.map